<template>
  <div>
    <div class="handle-box">
      <el-select class="el-select mr10" v-model="query.type">
        <el-option v-for="item in category_type" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="query.is_validate" clearable placeholder="是否有效" class="handle-select mr10">
        <el-option key="1" label="有效" value="1"></el-option>
        <el-option key="2" label="无效" value="0"></el-option>
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加</el-button>
    </div>
    <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header">
      <el-table-column prop="ID" label="ID" align="center"></el-table-column>
      <el-table-column label="名称" align="center">
        <template #default="scope">
          {{ scope.row.category_name }}
        </template>
      </el-table-column>
      <el-table-column label="类型" align="center">
        <template #default="scope">
          {{ categoryMap.get(scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column label="是否有效" align="center">
        <template #default="scope">
          <el-button type="text" :style="'color:' + [!scope.row.is_validate ? 'red' : '']"
            @click="setIsValidate(scope.$index, scope.row.ID, !scope.row.is_validate)">
            {{ scope.row.is_validate ? "有效" : "无效" }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="排序" align="center">
        <template #default="scope">
          {{ scope.row.sort }}
        </template>
      </el-table-column>
      <el-table-column prop="CreatedAt" label="创建时间" :formatter="dateRfcHMS" align="center" />
      <el-table-column label="操作" align="center">
        <template #default="scope">
          <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑
          </el-button>
          <el-button type="text" icon="el-icon-delete" class="red" @click="handleDelete(scope.row.ID)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination background layout="total, prev, pager, next" :current-page="query.page"
        :page-size="query.page_size" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
    </div>
    <!-- 编辑弹出框 -->
    <el-dialog :title="actTitle" v-model="editVisible" width="30%" align="center">
      <el-form ref="form" :model="form" class="el-dialog__body model-h" label-align="right">

        <el-form-item label="名称" required>
          <el-input v-model="form.category_name" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="分类类型：">
          <el-select class="el-select" v-model="form.type">
            <el-option v-for="item in category_type" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" required>
          <el-input-number v-model="form.sort" :precision="0" :min="0" :controls="false" :max="4294967295"
            style="width: 40%" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="editVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveEdit">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCategoryList,
  saveCategory,
  setCategoryIsValidate,
  delCategory
} from "@/api/category";
import { category_type } from "@/constant/category_type";

export default {
  name: "CategoryTable",
  data() {
    return {
      query: {
        recharge: "",
        is_validate: null,
        type: '',
        page: 1,
        page_size: 10
      },
      actTitle: "添加分类",
      form: {
        type: 'list'
      }, //提交表单数据
      tableData: [],
      pageTotal: 0,
      editVisible: false,
      categoryMap: new Map(),
    };
  },
  created() {
    this.getData();
    this.getCategoryMap()
  },
  computed: {
    category_type() {
      return category_type
    }
  },
  methods: {
    dateRfcHMS: function (row, column) {
      const date = row[column.property];
      if (date === undefined || date === 0) {
        return "";
      }
      return new Date(+new Date(date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
    },
    getCategoryMap() {
      this.category_type.forEach(item => {
        this.categoryMap.set(item.value, item.label)
      })
    },
    // 触发搜索按钮
    handleSearch() {
      this.query.page = 1
      this.getData()
    },
    // 搜索分类
    getData() {
      getCategoryList(this.query).then(res => {
        this.tableData = res.data
        if (this.query.page === 1) {
          this.pageTotal = res.count
        }
      })
    },
    save(row) {
      saveCategory(row.ID, row).then(res => {
        if (res) {
          this.$message.success('保存成功')
        }
        this.getData()
      })
    },

    // 删除操作
    handleDelete(id) {
      // 二次确认删除
      this.$confirm("确定要删除吗？", "删除提示", {
        type: "warning"
      }).then(() => {
        delCategory(id).then(res => {
          if (res === true) {
            this.$message.success("删除成功")
            this.getData()
          }
        })
      }).catch(() => {
      });
    },

    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },

    handleEdit(index, row) {
      this.idx = index;
      this.actTitle = "编辑分类"
      this.form.id = row.ID
      this.form.type = row.type
      this.form.category_name = row.category_name
      this.form.sort = row.sort
      this.editVisible = true

    },

    // 添加操作
    handleAdd() {
      this.form = {}
      this.form.id = 0
      this.form.sort = 1
      this.form.type = 'list'
      this.editVisible = true
    },

    saveEdit() {
      let paramData = Object.assign({}, this.form)

      saveCategory(this.form.id, paramData).then(res => {
        if (res === true) {
          this.$message.success("保存成功")
          this.getData()
          this.editVisible = false
        }
      })
    },


    setIsValidate(index, id, isvalidate) {
      setCategoryIsValidate(id, isvalidate).then(res => {
        if (res === true) {
          this.$message.success('保存成功')
          this.tableData[index].is_validate = isvalidate
        }
      })
    },

    // eslint-disable-next-line no-unused-vars
    handleAvatarSuccess(res, file) {
      this.form.cover = res.url
    },
    // eslint-disable-next-line no-unused-vars
    handleListSuccess(res, file) {
      this.form.image_list.push(res.url)
    }
  }
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 10px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 200px;
  display: inline-block;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}


.model-h {
  height: 20%;
}

.el-dialog__body {
  text-align: center;
}
</style>
